import React from "react";
import { Box, Typography } from "@mui/material";
import { TOKENS } from "./tokens";

/**
 * Title + subtitle + right-aligned actions slot.
 */
const PageHeader = ({ title, subtitle, actions }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-start",
      gap: 2,
      mb: "22px",
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography
        sx={{
          fontSize: 26,
          fontWeight: 700,
          letterSpacing: "-0.02em",
          lineHeight: 1.2,
          color: TOKENS.fg1,
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            fontSize: 14,
            color: TOKENS.fg2,
            mt: 0.5,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
    {actions ? <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>{actions}</Box> : null}
  </Box>
);

export default PageHeader;
